import { render, staticRenderFns } from "./SumupTransaction.vue?vue&type=template&id=68fcff77&"
import script from "./SumupTransaction.vue?vue&type=script&lang=js&"
export * from "./SumupTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SumupTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports